export enum ContentTypeEnum {
    BANNER = 'BANNER',
    IMAGE = 'IMAGE',
    TEXT_WITH_IMAGE = 'TEXT_WITH_IMAGE',
    TEXT_WITH_TITLE = 'TEXT_WITH_TITLE',
}
